import React, { useState } from 'react';
import { Nav, Box, CaretDownOutlined, Collapse, Text } from '@landr/maestro';
import { CollapseIconBox, StyledCollapse, StyledLeftBorder } from './styled';

interface NavigationMobileProps {
    children: React.ReactNode;
    title: string;
    icon: React.ElementType;
}

const NavigationMobile: React.FC<NavigationMobileProps> = ({
    children,
    title,
    icon: Icon,
}) => {
    const [isOpened, setIsOpened] = useState(false);

    const handleOnClick = (): void => {
        setIsOpened(!isOpened);
    };

    return (
        <Nav.Item>
            <StyledCollapse p={0} minHeight="unset">
                <Collapse.Trigger />
                <Collapse.Title
                    // Issue: Property 'onClick' does not exist on type
                    // https://github.com/LandrAudio/LANDR.Maestro/issues/973
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    onClick={handleOnClick}
                >
                    <Box display="flex" alignItems="center" px="16px" py="8px">
                        <Icon color={isOpened ? 'primary' : 'neutral.400'} />
                        <Box py="xs">
                            <Text
                                ml="xs"
                                fontWeight="700"
                                color={isOpened ? 'primary' : 'neutral.400'}
                            >
                                {title}
                            </Text>
                        </Box>
                        <Box display="flex" ml="md">
                            <CollapseIconBox isOpened={isOpened} height="24px">
                                <CaretDownOutlined
                                    color={isOpened ? 'primary' : 'neutral.400'}
                                />
                            </CollapseIconBox>
                        </Box>
                    </Box>
                </Collapse.Title>
                <Collapse.Content p="xs">
                    <StyledLeftBorder>{children}</StyledLeftBorder>
                </Collapse.Content>
            </StyledCollapse>
        </Nav.Item>
    );
};

interface ItemProps {
    onClick: (event: React.MouseEvent<Element, MouseEvent>) => void;
    path: string;
    text: string;
    target?: React.HTMLAttributeAnchorTarget;
}

const Item: React.FC<ItemProps> = ({ onClick, path, text, target }) => {
    return (
        <Nav.Link
            onClick={onClick}
            href={path}
            sx={{ whiteSpace: 'normal' }}
            target={target}
        >
            <Text fontWeight="bold" lineHeight="md" pl="14px">
                {text}
            </Text>
        </Nav.Link>
    );
};

export const NavCollapse = {
    Head: NavigationMobile,
    Item: Item,
};
